angular.module('bmsApp.settings').controller('UserManagementSaveCtrl',
	function ($scope, ngTableParams, $state, $q, UserManagementSvc, UserManagementRoleSvc, EmployeeSvc, $timeout, notify, FranchiseInstanceSvc) {

		$scope.updating = $state.is('main.settings.userManagement.edit');
		$scope.employeeId = $state.params.employeeId;
		$scope.processing = false;
		$scope.formValidator = {};
		$scope.loading = true;
		$scope.hasAdminRole = false;
		var promises = [];
		$scope.user = {
			roles: [],
		};

		var params = {
			filter: {
				UserType: ''
			}
		};
		promises.push(UserManagementRoleSvc.index(params));
		promises.push(FranchiseInstanceSvc.options(params));

		if ($scope.updating && $state.params.id) {
			promises.push(UserManagementSvc.read($state.params.id));
		}

		$q.all(promises)
			.then(function (responses) {
				$timeout(function () {
					$scope.roles = responses[0].data.role_collection;
					$scope.instanceOptions = responses[1].data.options;
					if ($scope.employeeId) {

						angular.forEach($scope.roles, (role, index) => {
							if (role.name === 'training') {
								$scope.user.roles.push(role);
							}
						});
					}
					if ($scope.updating && $state.params.id) {
						$scope.user = responses[2].data.user;

						$scope.rolesChanged();

					}

					if ($scope.employeeId) {
						let employeeId = $scope.employeeId;
						EmployeeSvc.read(employeeId).then((response) => {
							$scope.employee = response.data.employee;
							$scope.user.email = $scope.employee.email;
							$scope.user.username = $scope.employee.email;
							$scope.loading = false;
						});
					}
					else {
						$scope.loading = false;
					}

					$scope.$apply();
				});
			});

		$scope.userInstanceComparator = function (obj1, obj2) {
			return typeof obj1 !== 'undefined' && typeof obj2 !== 'undefined' && obj1.id === obj2.id;
		};

		$scope.rolesChanged = function() {
			$scope.hasAdminRole = false;
			angular.forEach($scope.user.roles, (role) => {
				if (role.name === 'bms_admin') {
					$scope.hasAdminRole = true;
				}
			});
		}

		$scope.submit = function (user) {
			$scope.processing = true;

			if ($scope.formValidator.valid()) {
				$scope.processing = true;

				if (!$scope.user.passwordUpdate && ! 'id' in user) {
					delete user.password;
				}

				if (angular.isObject($scope.employee)) {
					angular.extend(user, {
						employeeId: $scope.employee.id,
					});
				}

				var promise;
				promise = ($scope.updating) ?
					UserManagementSvc.update(user) :
					UserManagementSvc.create(user);

				promise.then(function (response) {
					notify({
						message: $scope.updating ? 'User successfully updated' : 'User successfully created'
					});
					processing = false;
					$state.go('main.settings.userManagement');
				}, function (error) {
					processing = false;
					$scope.errors = error;
				})
					.finally(function () {
						$scope.processing = false;
					});
			}else {
				$scope.processing = false;
			}
		};

	});





